export function createStopPayload(audioProgress: number, loquisLocaleId: number, audioLength: number) {
  return {
    source_ref: window.location.href,
    source_type: process.env.REACT_SOURCE_TYPE,
    section: 'challenge',
    loquis_locale_id: loquisLocaleId,
    audio_length: Math.floor(audioLength),
    audio_progress: Math.floor(audioProgress),
  };
}
